import type { CSSProperties } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { ALL_GRADES, MAINTENANCE_GRADE_COLORS } from "@/lib/fieldTypeCatalog";

export function GradeConfigPanel({
  enabledGrades,
  onToggle,
}: {
  enabledGrades: number[];
  onToggle: (g: number) => void;
}) {
  const set = new Set(enabledGrades);
  return (
    <div className="mb-grade-panel">
      <div>
        <h3 className="text-sm font-semibold text-label">Bewertungsskala</h3>
        <p className="mt-0.5 text-xs text-label-secondary">
          Welche Noten stehen bei Mängeln und Bewertungen zur Auswahl? Einfach an- und abklicken.
        </p>
      </div>
      <div className="mb-grade-grid" role="group" aria-label="Aktive Bewertungsnoten">
        {ALL_GRADES.map((g) => {
          const active = set.has(g);
          return (
            <button
              key={g}
              type="button"
              className="mb-grade-item"
              aria-pressed={active}
              style={{ "--mb-grade-color": MAINTENANCE_GRADE_COLORS[g] } as CSSProperties}
              onClick={() => onToggle(g)}
            >
              <span className="mb-grade-dot" aria-hidden>
                {active ? <CheckIcon /> : null}
              </span>
              <span>Note {g}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
